<div *ngIf="showModuleEditProduct" class="columns center container-main">
  <div class="column is-12-mobile is-10-tablet is-8-desktop is-8-widescreen is-6-fullhd">

    <!-- VERSION PARA MOVILES -->

    <div class="container-add-product mobile is-hidden-tablet">
      <div class="container-image-left mobile">
        <img class="img-product-main mobile" [src]="product.image" alt="">
      </div>
      <div class="container-options mobile">
        <img (click)="closeEditProduct()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <span class="name-product"> {{ product.name }} </span>
        <p class="description-product"> {{ product.description }} </p>
        <div *ngIf="gettingProduct" class="container-aditionals center" >
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        <div *ngIf="!gettingProduct" class="container-aditionals">

          <!-- LISTADO DE ADICIONALES -->
          <div
            *ngFor="let category of listAditionals"
            class="aditionals" >
            <div (click)="category.selected = !category.selected" class="header-aditionals">
              <span class="name-category-aditional">
                {{ category.name }} <br>
                <span class="info"> {{ category.message }} </span>
              </span>
              <img
                src="/assets/icons/arrow-ios.svg"
                [ngClass]="{'open': category.selected}"
                class="icon-aditional">
            </div>
            <div
              [ngClass]="{'open': category.selected}"
              class="list-options" >
              <div
                *ngFor="let aditional of category.aditionals"
                class="option">
                <div class="info-aditional">
                  <span class="name-option"> {{ aditional.name }} </span>
                  <span *ngIf="aditional.value != 0" class="value-option"> + {{ aditional.value }} </span>
                </div>

                <div (click)="selectAditional(aditional)" *ngIf="!aditional.stackable" >
                  <div *ngIf="aditional.selected" class="container-checkbox">
                    <img src="/assets/icons/checkbox-selected.svg" alt="" class="checkbox-box">
                    <img src="/assets/icons/check.svg" alt="" class="checkbox-check">
                  </div>
                  <div *ngIf="!aditional.selected" class="container-checkbox">
                    <img src="/assets/icons/checkbox.svg" alt="" class="checkbox-box">
                  </div>
                </div>
                <div *ngIf="aditional.stackable" >
                  <div class="container-menos-mas-aditional">
                    <div (click)="selectAditional(aditional, false)" class="btn-option">
                      <img src="/assets/icons/menos.svg" alt="" class="icon-option menos">
                    </div>
                    <span class="count-option"> {{ aditional.stackValue }} </span>
                    <div (click)="selectAditional(aditional, true)" class="btn-option">
                      <img src="/assets/icons/mas.svg" alt="" class="icon-option" >
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div [ngClass]="{'open': showObservation}" class="container-observation">
          <div (click)="openObservation()" class="header-observation">
            <span class="title">Observaciones</span>
            <span class="length-observation"> {{ product.note.length }}/150 </span>
          </div>
          <textarea class="observation" (keyup)="changeObservation($event)" placeholder="En este espacio puedes escribir una anotación o aclaración para la entrega de tu pedido." ></textarea>
        </div>
        <div class="container-options-footer">
          <!-- <div class="container-menos-mas">
            <div (click)="reduceAmount()" class="btn-option">
              <img src="/assets/icons/menos.svg" alt="" class="icon-option">
            </div>
            <span class="count-option"> {{ amountProducts }} </span>
            <div (click)="addAmount()" class="btn-option add">
              <img src="/assets/icons/mas.svg" alt="" >
            </div>
          </div> -->
          <div *ngIf="updatingProduct" class="container-loading center">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>
          <div *ngIf="!updatingProduct" (click)="updateShoppingCar()" class="container-btn-add">
            <span class="lema">Actualizar</span>
            <span class="mount"> {{ product.total | currency:'USD':symbol:'1.0-0' }} </span>
          </div>
        </div>
      </div>
    </div>


    <!-- VERSION DE ESCRITORIO -->

    <div class="container-add-product is-hidden-mobile">
      <div class="container-image-left">
        <img class="img-product-main" [src]="product.image" alt="">
      </div>
      <div class="container-options">
        <img (click)="closeEditProduct()" src="/assets/icons/close.svg" alt="" class="icon-close">
        <span class="name-product"> {{ product.name }} </span>
        <p class="description-product"> {{ product.description }} </p>
        <div *ngIf="gettingProduct" class="container-aditionals center" >
          <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        <div *ngIf="!gettingProduct" class="container-aditionals">

          <!-- LISTADO DE ADICIONALES -->
          <div
            *ngFor="let category of listAditionals"
            class="aditionals" >
            <div (click)="category.selected = !category.selected" class="header-aditionals">
              <span class="name-category-aditional">
                {{ category.name }} <br>
                <span class="info"> {{ category.message }} </span>
              </span>
              <img
                src="/assets/icons/arrow-ios.svg"
                [ngClass]="{'open': category.selected}"
                class="icon-aditional">
            </div>
            <div
              [ngClass]="{'open': category.selected}"
              class="list-options" >
              <div
                *ngFor="let aditional of category.aditionals"
                class="option">
                <div class="info-aditional">
                  <span class="name-option"> {{ aditional.name }} </span>
                  <span *ngIf="aditional.value != 0" class="value-option"> + {{ aditional.value }} </span>
                </div>

                <div (click)="selectAditional(aditional)" *ngIf="!aditional.stackable" >
                  <div *ngIf="aditional.selected" class="container-checkbox">
                    <img src="/assets/icons/checkbox-selected.svg" alt="" class="checkbox-box">
                    <img src="/assets/icons/check.svg" alt="" class="checkbox-check">
                  </div>
                  <div *ngIf="!aditional.selected" class="container-checkbox">
                    <img src="/assets/icons/checkbox.svg" alt="" class="checkbox-box">
                  </div>
                </div>
                <div *ngIf="aditional.stackable" >
                  <div class="container-menos-mas-aditional">
                    <div (click)="selectAditional(aditional, false)" class="btn-option">
                      <img src="/assets/icons/menos.svg" alt="" class="icon-option menos">
                    </div>
                    <span class="count-option"> {{ aditional.stackValue }} </span>
                    <div (click)="selectAditional(aditional, true)" class="btn-option">
                      <img src="/assets/icons/mas.svg" alt="" class="icon-option" >
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div [ngClass]="{'open': showObservation}" class="container-observation">
          <div (click)="openObservation()" class="header-observation">
            <span class="title">Observaciones</span>
            <span class="length-observation"> {{ product.note.length }}/150 </span>
          </div>
          <textarea class="observation" (keyup)="changeObservation($event)" placeholder="En este espacio puedes escribir una anotación o aclaración para la entrega de tu pedido." ></textarea>
        </div>
        <div class="container-options-footer">
          <!-- <div class="container-menos-mas">
            <div (click)="reduceAmount()" class="btn-option">
              <img src="/assets/icons/menos.svg" alt="" class="icon-option">
            </div>
            <span class="count-option"> {{ amountProducts }} </span>
            <div (click)="addAmount()" class="btn-option add">
              <img src="/assets/icons/mas.svg" alt="" >
            </div>
          </div> -->
          <div *ngIf="updatingProduct" class="container-loading center">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>
          <div *ngIf="!updatingProduct" (click)="updateShoppingCar()" class="container-btn-add">
            <span class="lema">Actualizar</span>
            <span class="mount"> {{ product.total | currency:'USD':symbol:'1.0-0' }} </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>